import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../services/auth.service';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
	dashboardData;
	constructor(private commonService: CommonService, private authService: AuthService) {
	

		// Enabling scrolling for Edge broswer
var refresh = localStorage.getItem('refresh');
if (refresh===null){

    window.location.reload();
    localStorage.setItem('refresh', "1");
}
	}


	
	ngOnInit() {
//  enabling scroll for Edge browser

		this.dashboardData = [];
		//this.commonService.setTitle();
		$(".navbar-brand").text("Dashboard");
		this.commonService.process();
		var service = this.commonService;
		setTimeout(function () { service.hideProcess(); }, 1000);
		this.getDashboardItem();
	}
	

	// Get dashboard item
	getDashboardItem = function () {
		//debugger;
	
		this.authService.getDashboardItem().subscribe(data=>{
	
			if(data.success){
			

		
				this.dashboardData = data.dashboard
			}
			this.commonService.hideProcess();
		});
	}

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/dashboard/dashboard.component.ts